module.exports = __webpack_public_path__ + "img/mint_julep.c9f4694f.jpg";